<template>
    <div
      class="relative"
      :class="[!valueEmpty ? 'not-empty' : '', disabled ? 'opacity-50' : '']"
    >
      <div>
        <span v-if="required" class="absolute right-0 pr-1 text-2xl text-red-500">*</span>
        <v-icon
          v-if="tooltip"
          name="helpCircle"
          class="absolute right-0 bottom-0 mb-1 mr-1 text-gray-400 bg-white"
          :size="4"
          v-tooltip="tooltip"
        />
        <div
          class="absolute right-0 bottom-0 mr-1 mb-1"
          v-if="multiple && inputValue && inputValue.length > localLimit"
        >
          <!-- <ToggleLink
            v-model="showAllValues"
            class="control-icon-btn restrict block p-1 cursor-pointer"
          >
            <v-icon
              name="expandAll"
              :class="[
                'h-4 w-4',
                showAllValues ? 'text-blue-600 hover:text-blue-700' : 'text-gray-400 hover:text-gray-500'
              ]"
            />
          </ToggleLink> -->
        </div>
        <div
          v-if="isLoading"
          class="absolute right-0 flex mr-1 mt-1"
          style="z-index: 10"
        >
          <!-- <Spinner color="green" :size="5" /> -->
        </div>
        <div
          v-show="!isLoading"
          class="absolute right-0 flex"
          style="z-index: 10"
          :class="(hasEnable && !localModifiers.enable) || disabled ? 'disabled-and-faded' : ''"
        >
          <slot name="beforeControlv-icons"></slot>
          <!-- <ToggleLink
            v-if="localModifiers.exclude != undefined && !hideModifiers"
            v-model="localModifiers.exclude"
            class="control-icon-btn restrict block p-1 cursor-pointer"
          >
            <v-icon
              name="cancel"
              :class="[
                'h-4 w-4',
                localModifiers.exclude ? 'text-red-600 hover:text-red-700' : 'text-gray-400 hover:text-gray-500'
              ]"
            />
          </ToggleLink> -->
          <!-- Additional ToggleLink components omitted for brevity -->
        </div>
        <div class="absolute right-0 bottom-0 flex" style="z-index: 9">
          <slot name="bottom-right"></slot>
        </div>
      </div>
      <MultiSelect
        v-if="!forceEdit"
        ref="multiselect"
        v-show="!editModeState"
        v-model="inputValue"
        :id="!editModeState ? id : undefined"
        :class="[
          localModifiers.exclude || localModifiers.isNot || forceRedTags ? 'exclude' : '',
          selectClass
        ]"
        :options="computedOptions"
        :custom-label="customLabel"
        :multiple="multiple"
        :placeholder="computedPlaceholder"
        :track-by="trackBy"
        :label="label"
        :inputLabel="title || undefined"
        :group-values="groupValues"
        :group-label="groupLabel"
        selectedLabel
        selectLabel
        deselectLabel
        :allow-empty="allowEmpty"
        :options-limit="optionsLimit"
        :internal-search="internalSearch"
        :clear-on-select="clearOnSelect"
        :limit="localLimit"
        :max-height="maxHeight"
        :show-no-results="showNoResults"
        :hide-selected="hideSelected"
        :taggable="taggable"
        @tag="addTag"
        @search-change="searchChangeMethod"
        @select="onSelect"
        @close="onClose"
        @remove="onRemove"
        @update:modelValue="updateValue"
        :disabled="(hasEnable && !localModifiers.enable) || disabled"
      >
      </MultiSelect>
      <!-- <MultiSelect
        v-if="multiple"
        v-show="editModeState"
        v-model="inputValue"
        :class="[selectClass]"
        :inputLabel="title || undefined"
        :id="editModeState ? id : undefined"
        :group-values="groupValues"
        :group-label="groupLabel"
        :exclude="modifiers.exclude"
        :placeholder="editPlaceholder"
        :track-by="trackBy || undefined"
        :label="label || undefined"

        :options="options"
        :disabled="(hasEnable && !modifiers.enable) || disabled"
        :option-required-on-tag="optionRequiredOnTag"
        @remove="onRemove"
      ></MultiSelect> -->
      <!-- <label :for="id" class="multiselect-label">{{ title }}</label> -->
      <slot name="footer"></slot>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, watchEffect } from 'vue'
  import { useQuery } from '@vue/apollo-composable'
  import MultiSelect from '@/components/common/MultiSelect.vue'
//   import ToggleLink from '@/components/legacy/ToggleLink'
//   import v-icon from '@/components/v-icon'
  
  // Define props and emit
  const props = defineProps({
    query: Object,
    queryVariables: Object,
    queryResultMap: Object,
    queryResultFunction: Function,
    queryDefaultInputText: String,
    queryFetchPolicy: String,
    modelValue: [String, Object, Array, Number, Boolean],
    title: String,
    customLabel: Function,
    hideModifiers: { type: Boolean, default: false },
    id: { type: String, default: () => Math.floor(Math.random() * 100000000).toString() },
    allowEmpty: { type: Boolean, default: true },
    groupValues: String,
    groupLabel: String,
    trackBy: String,
    label: String,
    modifiers: { type: Object, default: () => ({}) },
    settings: { type: Object, default: () => ({}) },
    options: { type: Array, default: () => [] },
    forceEdit: Boolean,
    placeholder: String,
    hideSelected: { type: Boolean, default: false },
    noResult: String,
    showNoResults: { type: Boolean, default: true },
    editPlaceholder: { type: String, default: 'Paste IDs' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    optionsLimit: { type: Number, default: 1000 },
    limit: { type: Number, default: 99999 },
    internalSearch: { type: Boolean, default: true },
    clearOnSelect: { type: Boolean, default: true },
    taggable: { type: Boolean, default: false },
    tooltip: String,
    selectClass: String,
    maxHeight: Number,
    focusOnMount: { type: Boolean, default: false },
    forceRedTags: Boolean,
    showCheckBoxes: { type: Boolean, default: false },
  })
  
  const emit = defineEmits([
    'update:modifiers',
    'select',
    'close',
    'remove',
    'search-change',
    'input',
    'update:modelValue'
  ])
  
  // Reactive variables
  const inputValue = ref(props.modelValue)
  const localModifiers = ref(props.modifiers)
  const editModeState = ref(props.forceEdit || props.modifiers.edit || props.settings.edit)
  const inputText = ref('')
  const showAllValues = ref(false)
  const localLimit = ref(props.limit)
  const internalOptions = ref([])
  
  // Apollo Query using `useQuery`
  const { result: queryResult, loading: isLoading } = useQuery(props.query, () => ({
    ...props.queryVariables,
    input: inputText.value || props.queryDefaultInputText
  }), {
    fetchPolicy: props.queryFetchPolicy || 'cache-first',
    debounce: 250
  })
  
  // Computed properties
  const valueEmpty = computed(() => !inputValue.value || inputValue.value.length === 0)
  const hasEnable = computed(() => localModifiers.value && localModifiers.value.enable != null)
  const computedPlaceholder = computed(() => props.placeholder ?? props.title ?? 'Select')
  
  const computedOptions = computed(() => {
    if (queryResult.value) {
      const queryData = queryResult.value[Object.keys(queryResult.value)[0]]
      const options = Array.isArray(queryData) ? queryData : (queryData?.data || [])
  
      if (props.queryResultMap) {
        return options.map(option => ({
          id: option[props.queryResultMap.id],
          label: option[props.queryResultMap.label]
        }))
      } else if (props.queryResultFunction) {
        return props.queryResultFunction(queryResult.value)
      }
      return options
    }
    return props.options ? [...props.options, ...internalOptions.value] : internalOptions.value
  })
  
  const computedNoResult = computed(() => props.noResult || `No ${props.title || 'Items'} Found`)
  
  // Methods
  function addTag(newTag) {
    const tag = props.trackBy ? { [props.trackBy]: newTag, [props.label]: newTag } : newTag
    internalOptions.value.push(tag)
    if (props.multiple) {
      inputValue.value.push(tag)
    } else {
      inputValue.value = tag
    }
  }
  
  function toggleIsNot(value) {
    if (isNotItems.value.includes(value)) {
      isNotItems.value = isNotItems.value.filter(item => item !== value)
    } else {
      isNotItems.value.push(value)
    }
  }
  
  function onSelect(value) {
    emit('select', value)
  }
  
  function onClose(value) {
    emit('close', value)
  }
  
  function onRemove(removedOption) {
    emit('remove', removedOption)
  }
  
  function searchChangeMethod(value) {
    inputText.value = value
    emit('search-change', value)
  }
  
  function updateEditMode() {
    if (props.modifiers.edit) {
      setTimeout(() => {
        document.getElementById(props.id)?.focus()
      }, 0)
    }
  }
  
  function updateValue(value) {
    emit('update:modelValue', value)
  }
  
  function initializeFocus() {
    if (props.focusOnMount) {
      document.getElementById(props.id)?.focus()
    }
  }
  
  // Initial setup
  initializeFocus()
  
  // isNotItems tracking
  const isNotItems = ref([])
  watchEffect(isNotItems, (newValue) => {
    inputValue.value = inputValue.value.map(item => {
      item.isNot = newValue.includes(item[props.trackBy])
      return item
    })
  }, { deep: true })
  
  watchEffect(localModifiers, (newValue) => {
    emit('update:modifiers', newValue)
  }, { deep: true })
  </script>
  
  <style scoped>
  .control-icons.control-icons-right {
    position: absolute;
    right: 0;
  }
  </style>